import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/turnoLaboral/importer/turnoLaboralImporterActions';

export default importerReducers(actions);
